<template>
  <div class="yxtbiz-project-plan-select">
    <div class="yxtbiz-selector" @click="selectDraw = false">
      <!-- 左侧筛选项及table -->
      <div class="yxtbiz-selector__left">
        <!-- 筛选项 -->
        <div class="clearfix font-size-14">
          <!-- 新增机构选择 -->
          <yxtbiz-group-org-select
            v-if="groupSelect"
            class="pull-left mr10 mb10 ml10"
            :placeholder="$t('pc_biz_kng_lbl_chooseorg' /*请选择机构*/)"
            set-current-org
            function-code="group_data_center"
            data-permission-code="data_manage_platform"
            :clearable="false"
            @change="orgIdchange"
            :disabledOrgIds="[]"
            :hideOrgIds="[]"
            :visibleOrgIds="[]"
            :selected="[]"
          />
          <yxt-popover
            :append-to-body='false'
            popper-class='yxtbiz-user-selector-popover'
            trigger='manual'
            placement='bottom-start'
            :visible-arrow='false'
            v-model='selectDraw'
          >
            <yxt-button plain slot='reference' class="yxtbiz-filter-btn pull-left mr12" :disabled="moreSearch" @click.stop="selectDraw = !selectDraw">
              <yxt-svg class="v-mid mr2 mb4" width="18px" height="18px" icon-class="filter" />
              {{ $t('pc_biz_common_lbl_moreFilter' /*更多筛选*/) }}
              <yxt-svg v-if="selectDraw" class="v-mid ml8" width="14px" height="14px" icon-class="arrow-up" />
              <yxt-svg v-else class="v-mid ml8" width="14px" height="14px" icon-class="arrow-down" />
            </yxt-button>
            <div v-show="selectDraw" class="clearfix font-size-14 more-select show-more" @click="selectDraw = true">
              <!-- 项目发布时间 -->
              <div class="pull-left mb10 flex-center">
                <label
                  class="reportor-form__label draw-label mr12"
                  v-text="$t('pc_biz_lbl_plan_time' /* 计划时间 */)"
                />
                <yxt-date-picker
                  v-model="dataRangeVal"
                  class="reportor-form__content w330"
                  type="daterange"
                  :range-separator="$t('pc_biz_ls_to' /* 至 */)"
                  :start-placeholder="$t('pc_biz_ls_start' /* 开始日期 */)"
                  :end-placeholder="$t('pc_biz_ls_end' /* 结束日期 */)"
                  @change="onChangeDate"
                />
              </div>
              <div class="pull-left mb10 flex-center">
                <label class="reportor-form__label draw-label mr12" v-text="$t('pc_biz_lbl_action_dpart' /* 实施部门*/)" />
                <readonly-input
                  class="nowrap ellipsis w330 d-in-block"
                  :placeholder="$t('pc_biz_lbl_selecttip'/*请选择*/)"
                  clearable
                  @clear="clearDpart"
                  @click="openDrawer">
                  <yxtbiz-dept-name v-if="projectSearch.departName" :name="projectSearch.departName" /> <!-- 部门选择 -->
                  <i slot="suffix"
                    class="yxt-icon-arrow-down"></i>
                </readonly-input>
              </div>
              <div class="pull-left mb10 flex-center">
                  <label class="reportor-form__label draw-label mr12" v-text="$t('pc_biz_lbl_plan_kind' /* 计划类别*/)" />
                  <yxt-select v-model="category"
                              class="w154"
                              :placeholder="$t('pc_biz_lbl_plan_kind'/*计划类别*/)"
                              clearable
                              @change="changeCategory">
                    <yxt-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id"
                    >
                    </yxt-option>
                  </yxt-select>
                  <plan-date v-model="projectSearch.scheduled"
                            class="ml12"
                            :disabled="category === 3 || category === null  || category === ''"
                            :category="category"/>
              </div>
              <!--计划状态-->
              <div class="pull-left mb10 flex-center">
                <label
                  class="reportor-form__label draw-label mr12"
                  v-text="$t('pc_biz_plan_status' /* 计划状态 */)"
                />
                  <yxt-select v-model="projectSearch.showStatus"
                              class="draw-select w330"
                              :placeholder="$t('pc_biz_lbl_selecttip'/*请选择*/)"
                              clearable>
                    <yxt-option
                      v-for="item in selectStatusArr"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type"
                    >
                    </yxt-option>
                  </yxt-select>
                </div>
              <div class="pull-left" />
            </div>
          </yxt-popover>
          <!-- 请输入计划名称搜索 -->
          <yxt-input
            v-model="projectSearch.planName"
            class="yxtbiz-selector__input pull-left"
            :placeholder="$t('pc_biz_o2o_plan_placeholder_text' /* 请输入计划名称搜索 */)"
            searchable
            clearable
            maxlength="50"
            @clear="projectNameSearch"
            @search="projectNameSearch"
          />
        </div>
        <!-- table -->
        <div class="yxtbiz-selector__main mt16">
          <!-- 加key以后换行自动跳到table页头 -->
          <yxt-table
            ref="refTable"
            :key="'projectTable' + page"
            v-loading="loading"
            class="yxtbiz-selector__table"
            :data="projectList"
            :default-sort="{ prop: 'releaseDate', order: 'desc' }"
            @select-all="selectAll"
            @select="select"
            @sort-change="sortChange"
          >
            <yxt-table-column :show-overflow-tooltip="false" type="selection" width="38" align="right" clear-padding="left-right" />
            <yxt-table-column :label="$t('pc_biz_project_train_plan_name'/*培训计划名称*/)" :show-overflow-tooltip="false">
              <template slot-scope="scope">
                <div class="sign-flex-style">
                  <yxt-tooltip class="overflow" effect="dark" :open-filter="true" :content="scope.row.planName" placement="top">
                    <span>{{ scope.row.planName }}</span>
                  </yxt-tooltip>
                  <!-- 0项目 1项目模板 2:集团化项目 -->
                  <span v-if="scope.row.type === 2" class="sign-text-style">{{ $t('pc_biz_ls_group') /* 集团*/ }}</span>
                </div>
              </template>
            </yxt-table-column>
            <yxt-table-column :label="$t('pc_biz_lbl_plan_kind'/*计划类别*/)" :show-overflow-tooltip="false" align="center">
              <template slot-scope="scope">
                <yxt-tooltip class="overflow" effect="dark" :open-filter="true" :content="categoryList[scope.row.category+1].text" placement="top">
                    <span>{{ categoryList[scope.row.category+1].text || '--' }}</span>
                  </yxt-tooltip>
              </template>
            </yxt-table-column>
            <yxt-table-column
              align="center"
              prop="planYear"
              :label="$t('pc_biz_lbl_plan_cycle'/*计划周期*/)"
              min-width="100">
              <template slot-scope="scope">
                <div>{{ getYQMDate(scope.row) }}</div>
              </template>
            </yxt-table-column>
            <yxt-table-column :label="$t('pc_biz_plan_status' /*计划状态*/)" prop="status" align="left" width="100">
              <template slot-scope="scope">
                <span :class="['yxtbiz-selector__project-status', `yxtbiz-selector__project-status--${scope.row.showStatus}`]" />
                <span>
                  {{ getStatusName(scope.row.showStatus) }}
                </span>
              </template>
            </yxt-table-column>
            <yxt-table-column
              :label="$t('pc_biz_lbl_creator'/*创建人*/)"
              show-overflow-tooltip
              popover-html
              prop="createUserName"
              align="left"
              width="120"
            >
              <template slot-scope="scope">
                <yxtbiz-user-name :name="scope.row.createUserName || '--'" />
              </template>
            </yxt-table-column>
          </yxt-table>
        </div>
        <div class="mt16 clearfix pr">
          <yxt-button type="text" :loading="selectAllBtnLoading" :disabled="!projectList.length" @click="handleSelectAll">
              {{$t('pc_biz_kng_selectall'/** 筛选全部结果 */)}}
          </yxt-button>
          <yxt-pagination
            class="pull-right"
            :page-size="projectSearch.size"
            :total="count"
            :current-page="page"
            layout="total, prev, pager, next"
            @current-change="pageChange"
          />
        </div>
      </div>
      <!-- 右侧已选项 -->
      <div class="yxtbiz-selector__right">
        <div class="yxtbiz-checked_list">
          <div class="yxtbiz-checked_list__select">
            <!-- 已选择 -->
            {{ $t('pc_biz_ote_lbl_chosenquestions' /*已选择*/) }}:&nbsp;&nbsp;{{ list && list.length }} / {{limit}}
          </div>
          <div class="yxtbiz-checked_list__box">
            <yxt-scrollbar :fit-height="true" class="yxtbiz-checked_list__scrollbar">
              <div v-for="(item, index) in list" :key="item.id" class="yxtbiz-checked_list__item">
                <yxt-tag disable-transitions size="small" type="info" closable @close="deleteItem(item, index)">
                  <yxt-tooltip :content="item.planName" open-filter>
                    <span class="yxtbiz-checked_list__item--tag">{{ item.planName }} </span>
                  </yxt-tooltip>
                </yxt-tag>
              </div>
            </yxt-scrollbar>
          </div>
          <div class="yxtbiz-checked_list__operation">
            <!-- 清除所有 -->
            <yxt-button class="font-size-12 color-gray-9 hover-primary-6" type="text" :disabled="list && list.length === 0" @click="clear">
              {{ $t('pc_biz_shoptour_clear_all' /*清除所有*/ ) }}
            </yxt-button>
          </div>
        </div>
      </div>
    </div>
      <!--部门抽屉-->
      <yxt-drawer
        ref="dPartDrawer"
        :title="$t('pc_biz_te_dept')"
        :visible.sync="dPartDrawer"
        :destroy-on-close="true"
        :before-close="depBeforeClose"
        size="640px"
      >
        <yxtbiz-dept-tree
          ref="deptTree"
          filterable
          :autosize="true"
          class="wline"
          :default-expanded-keys="[]"
          :functionCode="functionCode"
          :dataPermissionCode="deptDataPermissionCode"
          @inited="inited"
          @nodeClick="nodeClick">
        </yxtbiz-dept-tree>
        <div slot="footer">
          <yxt-button plain @click="handleCancel">{{ $t('pc_biz_common_cancel_mini') }}</yxt-button>
          <yxt-button type='primary' @click="handleComfirm">{{ $t('pc_biz_common_btn_sure') }}</yxt-button>
        </div>
      </yxt-drawer>
  </div>
</template>

<script>
import { dateFormat } from './util';
import { postProjectPlanList} from './service';
import PlanDate from './components/planDate.vue';
import ReadonlyInput from './components/readonly-input';
export default {
  name: 'YxtbizProjectPlanSelect',
  components: { PlanDate, ReadonlyInput },
  name_zh: '选择项目计划',
  eventList: [
    {
      type: 'projectInfo',
      handler: 'onProjectInfo',
      label: '已选项目数据'
    }
  ],
  props: {
    value: {
      type: Array,
      default: () => {return [];},
      desc: '绑定值，已选项目数组',
      setter: 'JsonSetter'
    },
    limit: {
      type: Number,
      default: 10000,
      desc: '可选项目最大数量，最大数量不能超过10000',
      setter: 'NumberSetter'
    },
    functionCode: {
      type: String,
      default: 'o2o_train_plan',
      desc: '功能权限码',
      setter: 'StringSetter'
    },
    dataPermissionCode: {
      type: String,
      default: 'plan_get_extent',
      desc: '数据权限码',
      setter: 'StringSetter'
    },
    deptDataPermissionCode: {
      type: String,
      default: '',
      desc: '部门抽屉的数据权限码',
      setter: 'StringSetter'
    },
    groupSelect: {
      type: Boolean,
      default: false,
      desc: '当前环境是否为集团版',
      setter: 'BooleanSetter'
    },
    userId: {
      type: String,
      default: '',
      desc: '用户id',
      setter: 'StringSetter'
    },
    orgId: {
      type: String,
      default: '',
      desc: '机构id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      page: 1,
      tableHeight: 0,
      // 下拉菜单 模式
      selectTypeArr: [
        { type: 0, name: this.$t('pc_biz_lbl_startEndTime') /** 起止时间模式 */ },
        { type: 2, name: this.$t('pc_biz_lbl_cycleMode') /** 周期模式 */ }
      ],
      // 下拉菜单 项目展示状态：0未开始 1进行中 2已结束
      selectStatusArr: [
        { type: null, name: this.$t('pc_biz_udp_lbl_unlimited'/* 不限 */) },
        { type: 0, name: this.$t('pc_biz_ls_notStart') /* 未开始 */ },
        { type: 1, name: this.$t('pc_biz_global_processing') /* 进行中 */ },
        { type: 2, name: this.$t('pc_biz_global_over') /* 已结束 */ }
      ],
      categoryList: [ // 计划类别 (0年度计划 1季度计划 2月度计划 3 临时计划)
        {
          text: this.$t('pc_biz_udp_lbl_unlimited'/* 不限 */),
          id: null
        },
        {
          text: this.$t('pc_biz_selectplan_year_plan'/* 年度计划 */),
          id: 0
        },
        {
          text: this.$t('pc_biz_selectplan_quarter_plan'/* 季度计划 */),
          id: 1
        },
        {
          text: this.$t('pc_biz_selectplan_month_plan'/* 月度计划 */),
          id: 2
        },
        {
          text: this.$t('pc_biz_selectplan_template_plan'/* 临时计划 */),
          id: 3
        }
      ],
      dPartDrawer: false,
      selectDepartName: '', // 选中部门名称
      selectDepartId: '', // 选中部门id
      category: null,
      dataRangeVal: ['', ''],
      projectSearch: {
        category: 0,
        scheduled: '',
        showStatus: null,
        endEndDate: '',
        endStartDate: '',
        authCode: this.groupSelect ? 'data_manage_platform' : this.dataPermissionCode, // dataPermissionCode
        planName: '',
        navCode: this.groupSelect ? 'group_data_center' : this.functionCode,
        orgId: this.orgId,
        mainOrgId: '', // 集团版指定要查询的机构
        sceneId: 0,
        order: 0,
        size: 50, // 每页数量
        page: 1, // 页码
        sort: 'DESC',
        dataPermCode: this.dataPermissionCode,
        status: 0,
        timeType: '',
        includeArchive: 0,
        userId: this.userId,
        departName: '',
        deptIds: []
      },
      drawerVisible: false,
      loaded: 1,
      loading: false,
      totalPage: 0,
      count: 0,
      projectList: [],
      selected: {},
      selectDraw: false,
      typeName: '', // 项目模式
      moreSearch: false, // 更多筛选
      selectAllBtnLoading: false
    };
  },

  watch: {
    value(val) {
      this.onValueChanged(val);
    },
    'projectSearch.showStatus'() {
      this.getProjectList(true);
    },
    'projectSearch.scheduled'() {
      console.log(this.projectSearch.scheduled);
      console.log(this.category);
      this.getProjectList(true);
    }
  },

  computed: {
    list() {
      return this.selected && Object.values(this.selected);
    }
  },

  created() {
    this.open();
    // TODO 优化
    this.$nextTick(()=>{
      const reportSelectDom = document.getElementById('reportSelector');
      reportSelectDom && reportSelectDom.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (e.target.className.indexOf('yxt-range-input') > -1) {
          this.selectDraw = true;
        }
      });
    });
    this.getTableHeight();
  },

  mounted() {
    // 挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },

  methods: {
    getYQMDate(row) {
      const data = [
        {
          label: 'planYear',
          format: 'yyyy'
        },
        {
          label: 'scheduled',
          format: ''
        },
        {
          label: 'scheduled',
          format: 'yyyy' + '-' + 'MM'
        }
      ];
      const category = data[row.category];
      if (!category) return '--';
      const date = new Date(String(row[category.label]).replace(/-/g, '/'));
      if (!category.format) {
        const [y, q] = row[category.label].split('-');
        return y + (q ? '-' + q : '');
      }
      return dateFormat(date, category.format);
    },
    changeCategory(val) {
      this.projectSearch.category = this.isNumber(val) ? val : '';
      this.getProjectList(true);
    },
    isNumber(value) {
      return typeof value === 'number' && !isNaN(value);
    },
    // 清空部门
    clearDpart() {
      this.projectSearch.departName = '';
      this.projectSearch.deptIds = [];
      this.getProjectList(true);
    },
    // 打开选择部门抽屉
    openDrawer() {
      this.dPartDrawer = true;
    },
    depBeforeClose(done) {
      done(false);
    },
    // 设置部门默认值
    inited() {
      this.$nextTick(() => {
        this.$refs.deptTree && this.$refs.deptTree.setCurrentKey(this.projectSearch.deptIds);
      });
    },
    // 选择部门
    nodeClick(a, b, c) {
      this.selectDepartName = a.name;
      this.selectDepartId = a.id;
    },
    // 选择部门确定
    handleComfirm() {
      this.projectSearch.departName = this.selectDepartName;
      this.projectSearch.deptIds = [this.selectDepartId];
      this.dPartDrawer = false;
      this.getProjectList(true);
    },
    // 关闭选择部门弹框
    handleCancel() {
      this.$refs.dPartDrawer.closeDrawer();
    },

    // 项目模式
    onTypeSelect($event) {
      let timeType = this.selectTypeArr.filter(item=>item.name === $event).length ? this.selectTypeArr.filter(item=>item.name === $event)[0].type : '';
      this.projectSearch.timeType = timeType === 2 ? 1 : timeType;
      this.getProjectList();
    },

    // 切换查询平台
    orgIdchange(orgInfo) {
      this.projectSearch.mainOrgId = orgInfo.orgId;
      this.getProjectList(true); // 重新重置请求数据
    },

    // 重新打开的时候初始化 选择内容
    open() {
      this.typeName = '';
      this.dataRangeVal = ['', ''];
      this.projectSearch.category = '';
      this.projectSearch.name = '';
      this.formatModel(this.value);
      !this.groupSelect && this.getProjectList(true);
      this.drawerVisible = true;
      this.selectDraw = false;
      this.projectSearch.releaseStartTime = '';
      this.projectSearch.releaseEndTime = '';
      this.projectSearch.timeType = '';
      this.projectSearch.status = 0;
      this.getProjectList(true);
    },

    hide() {
      this.drawerVisible = false;
      this.selectDraw = false;
    },

    submit() {
      const isLimited = this.list.length > this.limit;
      if (isLimited) {
        this.$message.warning(this.$t('pc_biz_msg_plancountlimit', [this.limit]));
        return;
      }
      this.outPut('1');
      this.hide();
    },

    // 项目状态 	计划状态：0未开始 1进行中 2已结束
    getStatusName(status) {
      let sName = '';
      switch (status) {
        case 0:
          sName = this.$t('pc_biz_ls_notStart'); // 未开始
          break;
        case 1:
          sName = this.$t('pc_biz_global_processing'); // 进行中
          break;
        case 2:
          sName = this.$t('pc_biz_global_over'); // 已结束
          break;
        default:
          break;
      }
      return sName;
    },

    // 请求项目表格
    getProjectList(isReset) {
      this.moreSearch = true;
      if (isReset) {
        this.page = 1;
        this.projectSearch.page = 1;
      }

      this.projectSearch.planName = this.projectSearch.planName.trim();
      this.loading = true;
      const projectUrl = this.groupSelect ? postProjectPlanList(this.projectSearch) : postProjectPlanList(this.projectSearch);
      projectUrl.then((result) => {
        this.projectList = result.datas;
        this.totalPage = result.paging.pages;
        this.count = result.paging.count;
        this.loaded--;
        this.loading = false;
        this.$nextTick(() => {
          this.setChecked();
        });
      })
        .catch(this.handleError.bind(this))
        .finally(() => {
          this.moreSearch = false;
        });
    },
    // 修改时间查询
    onChangeDate(dateRange) {
      if (dateRange) {
        this.dataRangeVal = [dateFormat(dateRange[0], 'yyyy-MM-dd'), dateFormat(dateRange[1], 'yyyy-MM-dd')];
        this.projectSearch.endStartDate = this.dataRangeVal[0] + ' 00:00:00';
        this.projectSearch.endEndDate = this.dataRangeVal[1] + ' 23:59:59';
      } else {
        this.projectSearch.endStartDate = '';
        this.projectSearch.endEndDate = '';
        this.dataRangeVal = ['', ''];
      }
      this.getProjectList(true);
    },
    // 输入框搜索项目
    projectNameSearch() {
      this.getProjectList(true);
    },
    sortChange(sort) {
      this.projectSearch.sort = sort.order;
      this.getProjectList();
      return false;
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.projectSearch.page = page;
      this.getProjectList();
    },

    // 选择某个
    select(item, row) {
      const isAdd = item.some(v => {
        return v.planId === row.planId;
      });
      if (!isAdd) {
        delete this.selected[row.planId];
      } else {
        const isLimited = Object.keys(this.selected).length + 1 > this.limit;
        // 判断：如果超出最大数量则不能添加
        if (isLimited) {
          this.$message.warning(this.$t('pc_biz_msg_plancountlimit', [this.limit]));
          let del_row = item.pop();
          this.$refs.refTable.toggleRowSelection(del_row, false);
          return false;
        }
        this.selected[row.planId] = row;
      }
      this.$forceUpdate();
      this.outPut();
    },

    // 全选
    selectAll(data) {
      const isAdd = data.length !== 0;
      if (isAdd) {
        // 添加项目操作
        let number = this.limit - Object.keys(this.selected).length;
        let dataSpareInfo = [];
        data.map(item=>{
          if (!Object.keys(this.selected).includes(item.planId)) {
            dataSpareInfo.push(item);
          }
        });
        // 不能用data.length,因为一页里面有俩个未选的情况，再点全选也会报错
        if (number < dataSpareInfo.length) {
          this.$message.warning(this.$t('pc_biz_msg_plancountlimit', [this.limit]));
          this.projectList.forEach(obj => {
            this.$nextTick(()=>{
              if (!Object.keys(this.selected).includes(obj.id)) {
                this.$refs.refTable.toggleRowSelection(obj, false);
              }
            });
          });
        } else {
          this.projectList.forEach(obj => {
            this.selected[obj.planId] = obj;
          });
        }
      } else {
        // 删项目操作
        this.projectList.forEach(obj => {
          delete this.selected[obj.planId];
        });
      }
      this.$forceUpdate();
      this.outPut();
    },

    outPut(input = '') {
      const selArray = Object.values(this.selected);
      this.$emit('projectInfo', selArray);
      // input && this.handleToInput(selArray);
      this.onValueChanged(selArray);
    },

    onValueChanged(val) {
      this.formatModel(val);
    },

    formatModel(v) {
      this.selected = {};
      v.forEach(obj => {
        this.selected[obj.planId] = obj;
      });
    },

    // 删除已选择
    deleteItem(item) {
      let row = item;
      for (let index = 0; index < this.projectList.length; index++) {
        const element = this.projectList[index];
        if (element.planId === item.planId) {
          row = element;
          break;
        }
      }
      if (row) {
        this.$refs.refTable.toggleRowSelection(row, false);
      }
      delete this.selected[item.planId];
      this.$forceUpdate();
      this.outPut();
    },

    // 清空
    clear() {
      let row = null;
      for (const key in this.selected) {
        if (Object.prototype.hasOwnProperty.call(this.selected, key)) {
          for (let index = 0; index < this.projectList.length; index++) {
            const element = this.projectList[index];
            if (element.planId === key) {
              row = element;
              break;
            }
          }
          if (row) {
            this.$refs.refTable.toggleRowSelection(row, false);
          }
        }
      }
      this.selected = {};
      this.outPut();
    },

    setChecked() {
      this.$nextTick(()=>{
        this.projectList.forEach(obj => {
          if (Object.prototype.hasOwnProperty.call(this.selected, obj.planId)) {
            this.$refs.refTable.toggleRowSelection(obj, true);
          } else {
            this.$refs.refTable.toggleRowSelection(obj, false);
          }
        });
      });
    },

    resetAll() {
      this.projectList = [];
      this.selected = {};
      this.handleToInput([]);
    },

    beforeClose(done) {
      done(this.list.map(item => item.planId).join() !== this.value.map(item => item.planId).join());
    },

    handleError(error) {
      error = error.error;
      let msg = error.message;
      this.$message({
        message: msg,
        type: 'error'
      });
    },

    isUndefined(val) {
      return val === undefined ? '' : val;
    },

    getFiteredData(list, originList) {
      let number = this.limit - Object.keys(originList).length;
      let count = 0;
      let checkedList = JSON.parse(JSON.stringify(originList));
      if (number) {
        list.forEach((i, index)=>{
          if (number > count) {
            if (!Object.keys(originList).includes(i.planId)) {
              checkedList[i.planId] = i;
              count++;
            }
          }
        });
      } else {
        this.$message.warning(this.$t('pc_biz_msg_plancountlimit', [this.limit]));
      }
      return checkedList;
    },

    // 将selected知识设为true
    selectedTrue(data, refTable) {
      const ids = (this.list || []).map(item => item.planId);
      data.forEach(kng => {
        if (ids.includes(kng.planId) || ids.includes(kng.kngId)) {
          this.$nextTick(() => {
            refTable.toggleRowSelection(kng, true);
          });
        }
      });
    },

    // 全部筛选结果
    handleSelectAll() {
      this.selectAllBtnLoading = true;
      let params = JSON.parse(JSON.stringify(this.projectSearch));
      params.size = this.limit > 0 ? this.limit : this.count;
      params.page = 1;
      let request = this.groupSelect ? postProjectPlanList(params) : postProjectPlanList(params);
      request.then(res => {
        this.selected = this.getFiteredData(res.datas, this.selected);
        this.outPut();
        this.$nextTick(() => this.selectedTrue(this.projectList, this.$refs.refTable));
      }).finally(() =>{
        this.selectAllBtnLoading = false;
      });
    },

    // 计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 0; // 距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// @import '@/components/Selector/selector';
// @import '../style';
// 筛选更多 弹窗style
.yxtbiz-project-plan-select{
  height: 100%;
}

.pr10 {
  padding-right: 10px;
}

.more-select {
  position: absolute;
  z-index: 2010;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 98%;
  height: auto;
  padding-top: 20px;
  background: #fff;
  // box-shadow: 0 4px 24px 0 rgb(0 0 0 / 12%);

  .draw-label {
    width: 100px;
    text-align: right;
  }

  .w330 {
    width: 330px !important;
  }

  .mr14 {
    margin-right: 14px;
  }

  & > div:nth-child(odd) {
    text-align: right;
  }

  & > div {
    flex: 1;
    width: 47%;
    min-width: 47%;
  }
}

.mb4 {
  margin-bottom: 4px;
}

.sign-flex-style {
  display: flex;
  align-items: center;
  box-sizing: border-box;

  .overflow {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .sign-text-style {
    flex-shrink: 0;
    height: 22px;
    margin-left: 8px;
    padding: 0 6px;
    color: #736251;
    font-weight: 400;
    font-size: 12px;
    background: linear-gradient(90deg, #efd8b9 0%, #d7ad85 100%);
    border-radius: 2px;
  }
}

.sign-flex-style-center{
  justify-content: center;
}

.yxtbiz-checked_list__scrollbar ::v-deep .yxt-scrollbar__wrap {
  overflow: auto !important;
  height: 100% !important;
}
</style>
